import Btn from "../Btn";
import Tx from "../Tx";
import { useState } from "react";
import CameraDialog from "../dialogs/CameraDialog";
import { useEffect } from "react";
import { api } from "../../maps/data.js";
import InstallerCameraCard from "./InstallerCameraCard";
import StoresColumn from "../StoresColumn";

export default function StoresCameras(props) {
  const [open_camera_dialog, s_open_camera_dialog] = useState(false);
  const [new_camera, s_new_camera] = useState(false);
  const [cameras, s_cameras] = useState([]);
  const [edit_item, s_edit_item] = useState({});
  const [showCameras, s_showCameras] = useState(true);

  const { selectedEdge, forceFieldUpdate, getSites, selectedSite } = props;

  const getCameras = async () => {
    const res = await api({
      type: "getCameras",
      data: {
        edgeId: selectedEdge._id,
      },
    });
    s_cameras(res);
  };

  useEffect(() => {
    getCameras();
  }, [selectedEdge._id]);

  return (
    <StoresColumn color="#fdd54660">
      {showCameras &&
        cameras.map((camera) => (
          <InstallerCameraCard
            key={camera._id}
            {...camera}
            onEdit={() => {
              s_new_camera(false);
              s_edit_item(camera);
              s_open_camera_dialog(true);
            }}
            onDelete={async () => {
              await api({
                type: "deleteCamera",
                data: { cameraId: camera._id },
              });
              getCameras();
            }}
            onStartRecord={async () => {
              const timestampEnd = Date.now();
console.log(camera)
              await api({
                type: "captureCameraStream",
                data: {
                  cameraId: camera._id,
                  edgeId: props.selectedEdge._id,
                  siteId: props.selectedEdge.siteId,
                //   alertId: data._id,
                //   box: cam.box?.box,
                  timestampStart: timestampEnd - 15000,
                  timestampEnd: timestampEnd,
                  exactTime: timestampEnd,
                  shelfId: Math.round(Math.random()*1000000000),
                },
              });
              //   addComments();
            }}
          />
        ))}
      <div>
        <Btn
          startIcon="camera"
          onClick={() => {
            s_new_camera(true);
            s_edit_item({});
            s_open_camera_dialog(true);
          }}
        >
          <Tx>g.add</Tx>
        </Btn>
      </div>
      {open_camera_dialog && (
        <CameraDialog
          forceFieldUpdate={() => {
            s_showCameras(false);
            forceFieldUpdate();
            setTimeout(() => {
              s_showCameras(true);
            }, 300);
          }}
          forceSiteUpdate={() => {
            getSites();
          }}
          site={selectedSite}
          edge={props.selectedEdge}
          edgeId={props.selectedEdge._id}
          open={open_camera_dialog}
          newCamera={new_camera}
          camera={edit_item}
          onClose={() => {
            s_open_camera_dialog(false);
            getCameras();
          }}
        />
      )}
    </StoresColumn>
  );
}
